require("packs/bookmarks")
import { fetchAPI } from "packs/api";
import { staggerCards } from "packs/card_stagger";
require("packs/home_widget");
import "stylesheets/home.css";
import { initializeBannerSwiper, initializeStaticBannerClicks } from 'shared/banner_utils';

document.addEventListener("DOMContentLoaded", () => {
  const openModalReviews = document.querySelector(".open-modal-reviews");
  if (openModalReviews) {
    openModalReviews.addEventListener("click", function () {
      const merchantId = openModalReviews.dataset.merchantId;
      fetchAPI(`/reviews`, "GET", { merchant_id: merchantId }, "script");
    });
  }

  // show coupon popup
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("coupon_id") && urlParams.get("coupon_id") != "") {
    var couponId = urlParams.get("coupon_id");
    var permalink = document.querySelector('.store-permalink').dataset.permalink;
    var popupUrl =
      "/stores/" + permalink + "/coupons/" + couponId + "?modal=true";
    // calling coupon show action
    fetchAPI(popupUrl, "GET", {}, "script");
  }

  // Change tabs Code
  let changeTabElements = document.querySelectorAll(".change-tab");
  changeTabElements.forEach((changeTab) => {
    changeTab.addEventListener("click", function () {
      let clickedTab = this.dataset.tab;
      let allTabs = document.querySelectorAll(".change-tab");
      let allTabsContent = document.querySelectorAll(".store-tab-content");
      allTabs.forEach((tab) => {
        let tabName = tab.dataset.tab;
        if (tabName === clickedTab) {
          this.style.color = "var(--color-primary)";
          this.style.borderColor = "var(--color-primary)";
        } else {
          tab.style.color = "";
          tab.style.borderColor = "";
        }
      });
      allTabsContent.forEach((tabContent) => {
        let tabName = tabContent.id;
        if (tabName === clickedTab) {
          tabContent.classList.remove("hidden");
        } else {
          tabContent.classList.add("hidden");
        }
      });
      // Update H2 heading based on active tab
      let storeTabHeading = document.getElementById("store-tab-heading");
      if (storeTabHeading) {
        if (clickedTab === "tab-all") {
          storeTabHeading.textContent = storeTabHeading.dataset.allText;
        } else if (clickedTab === "tab-deals") {
          storeTabHeading.textContent = storeTabHeading.dataset.dealsText;
        } else if (clickedTab === "tab-coupons") {
          storeTabHeading.textContent = storeTabHeading.dataset.couponsText;
        }
      }
    });
  });

  // Show more deals and coupons button

  const viewAllCouponBtn = document.querySelector(".view-all-coupon");
  if (viewAllCouponBtn) {
    viewAllCouponBtn.addEventListener("click", function () {
      viewAllCouponBtn.parentNode.removeChild(viewAllCouponBtn);
      const moreCoupons = document.querySelector(".more-coupons");
      moreCoupons.classList.remove("hidden");
    });
  }

  const viewAllDealsBtn = document.querySelector(".view-all-deals");
  if (viewAllDealsBtn) {
    viewAllDealsBtn.addEventListener("click", function () {
      viewAllDealsBtn.parentNode.removeChild(viewAllDealsBtn);
      const moreDeals = document.querySelector(".more-deals");
      moreDeals.classList.remove("hidden");
    });
  }
  
  // Initialize banner swiper if present (no autoplay for store)
  initializeBannerSwiper('store_page_swiper', { autoplay: false });
  
  initializeStaticBannerClicks();
  
  setEventsForCouponCards();
});

function setEventsForCouponCards() {
  // Use event delegation for description toggle (works with dynamically loaded content)
  let toggleDescContent = function (elem, status) {
    if (status == "open") {
      // Find the card container (parent grid element)
      let cardContainer = elem.closest('.card');
      if (cardContainer) {
        // Find the description content within the same card
        let descContent = cardContainer.querySelector('.desc-content');
        if (descContent) {
          // Hide the "Show More" button
          elem.classList.add('hidden');
          // Show the description content
          descContent.classList.remove('hidden');
        }
      }
    } else if (status == "close") {
      // Find the description content container
      let descContent = elem.closest('.desc-content');
      if (descContent) {
        // Find the card container
        let cardContainer = descContent.closest('.card');
        if (cardContainer) {
          // Find and show the "Show More" button again
          let moreInfoButton = cardContainer.querySelector(".desc-open-close");
          if (moreInfoButton) {
            moreInfoButton.classList.remove('hidden');
          }
          // Hide the description content
          descContent.classList.add('hidden');
        }
      }
    }
  };

  // Event delegation for description open buttons (only set up once)
  if (!window.storeDetailsDescOpenHandlerAdded) {
    document.body.addEventListener("click", function(event) {
      const descOpenClose = event.target.closest(".desc-open-close");
      if (descOpenClose) {
        event.preventDefault();
        event.stopPropagation();
        toggleDescContent(descOpenClose, "open");
      }
    });
    window.storeDetailsDescOpenHandlerAdded = true;
  }

  // Event delegation for description close buttons (only set up once)
  if (!window.storeDetailsDescCloseHandlerAdded) {
    document.body.addEventListener("click", function(event) {
      const descLess = event.target.closest(".desc-less");
      if (descLess) {
        event.preventDefault();
        event.stopPropagation();
        toggleDescContent(descLess, "close");
      }
    });
    window.storeDetailsDescCloseHandlerAdded = true;
  }

  // Event delegation for share icons (only set up once)
  if (!window.storeDetailsShareHandlerAdded) {
    document.body.addEventListener("click", function(event) {
      const shareIcon = event.target.closest(".shareIcon");
      if (shareIcon) {
        event.stopPropagation();
        let popupMenu = shareIcon.nextElementSibling;
        if (popupMenu && popupMenu.classList.contains('popupMenu')) {
          // Close all other open popups first
          document.querySelectorAll('.popupMenu').forEach(function(menu) {
            if (menu !== popupMenu && !menu.classList.contains('hidden')) {
              hideDropdownAnimated(menu);
            }
          });
          // Toggle the current popup
          if (popupMenu.classList.contains('hidden')) {
            showDropdownAnimated(popupMenu);
          } else {
            hideDropdownAnimated(popupMenu);
          }
        }
      }
    });
    window.storeDetailsShareHandlerAdded = true;
  }

  // Event delegation for close buttons inside popups (only set up once)
  if (!window.storeDetailsCloseDivHandlerAdded) {
    document.body.addEventListener("click", function(event) {
      const closeDiv = event.target.closest(".closediv");
      if (closeDiv) {
        event.stopPropagation();
        let popupMenu = closeDiv.closest('.popupMenu');
        if (popupMenu) {
          hideDropdownAnimated(popupMenu);
        }
      }
    });
    window.storeDetailsCloseDivHandlerAdded = true;
  }

  // Close popups when clicking outside (only set up once)
  if (!window.storeDetailsOutsideClickHandlerAdded) {
    document.body.addEventListener("click", function(event) {
      // If click is not on a popup menu or share icon, close all popups
      if (!event.target.closest('.popupMenu') && !event.target.closest('.shareIcon')) {
        document.querySelectorAll('.popupMenu').forEach(function(menu) {
          if (!menu.classList.contains('hidden')) {
            hideDropdownAnimated(menu);
          }
        });
      }
    });
    window.storeDetailsOutsideClickHandlerAdded = true;
  }
}

window.setEventsForCouponCards = setEventsForCouponCards;

// Use event delegation for coupon code copy functionality (only set up once)
// This ensures it works with dynamically loaded content and prevents duplicate animations
if (!window.storeCouponCopyHandlerAdded) {
  document.body.addEventListener("click", function(event) {
    const copyIcon = event.target.closest(".coupon-code-copy");
    if (copyIcon) {
      event.preventDefault();
      event.stopPropagation();

      // Find the coupon code text (next sibling of the copy icon)
      let textToCopy = copyIcon.nextElementSibling ? copyIcon.nextElementSibling.innerText : '';

      if (textToCopy) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            if (window.showCopiedAnimation) {
              window.showCopiedAnimation(copyIcon);
            }
          })
          .catch((err) => {
            console.error("Unable to copy text: ", err);
          });
      }
    }
  });
  window.storeCouponCopyHandlerAdded = true;
}